const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "Nuhwilai Blog", // <title>
  shortSiteTitle: "", // <title> ending for posts and pages
  siteDescription: "Personal Blog",
  siteUrl: "https://new.assanee.com",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "thanaporn nuwilai",
  // authorTwitterAccount: "greglobinski",
  // info
  infoTitle: "thanaporn",
  infoTitleNote: "personal blog",
  // manifest.json
  manifestName: "Nuhwilai Blog",
  manifestShortName: "Nuhwilai Blog", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "new@bonmek.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/nuhwilai" },
    { name: "email", url: "mailto:new@bonmek.com" }
    // { name: "twitter", url: "https://twitter.com/greglobinski" },
    // { name: "facebook", url: "https://facebook.com/greglobinski" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js